/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
export const constantRouterMap = [
  {
    path: "/test",
    name: "Test",
    component: () => import("@/views/test/Index"),
    meta: { title: "测试" }
  },
  {
    path: "/share/moment/:id",
    name: "momentDetail",
    component: () => import("@/views/share/moment"),
    meta: { title: "帖子详情" }
  },
  {
    path: "/share/proxy/:id",
    name: "proxyDetail",
    component: () => import("@/views/share/proxy"),
    meta: { title: "供应详情" }
  },
  {
    path: "/share/purchase/:id",
    name: "purchaseDetail",
    component: () => import("@/views/share/purchase"),
    meta: { title: "采购详情" }
  },
  {
    path: "/share/factory/:id",
    name: "factoryDetail",
    component: () => import("@/views/share/factory"),
    meta: { title: "工厂详情" }
  },
  {
    path: "/share/qninfo",
    name: "qninfo",
    component: () => import("@/views/share/qninfo"),
    meta: { title: "工厂详情" }
  },
  {
    path: "/share/article/:id",
    name: "article",
    component: () => import("@/views/share/article"),
    meta: { title: "文章详情" }
  },
  {
    path: "/static/privacy",
    name: "privacy",
    component: () => import("@/views/static/privacy"),
    meta: { title: "用户隐私权保护声明" }
  },
  {
    path: "/static/cloudPrintPrivacy",
    name: "cloudPrintPrivacy",
    component: () => import("@/views/static/cloudPrintPrivacy"),
    meta: { title: "用户隐私权保护声明" }
  },
  {
    path: "/share/InformationDerived",
    name: "InformationDerived",
    component: () => import("@/views/share/InformationDerived"),
    meta: { title: "信息导出" }
  },
  {
    path: "/share/livePrice/verticalScreen",
    name: "LivePrice",
    component: () => import("@/views/share/LivePriceVerticalScreen"),
    meta: { title: "直播价格展示竖屏" }
  },
  {
    path: "/share/livePrice/landscape",
    name: "LivePrice",
    component: () => import("@/views/share/LivePriceLandscape"),
    meta: { title: "直播价格展示横屏" }
  },
  {
    path: "/share/liveSku",
    name: "LiveSku",
    component: () => import("@/views/share/liveSku/Index"),
    meta: { title: "实时报价" }
  },
  {
    path: "/share/ztbFactoryUserPrivacy",
    name: "ZtbFactoryUserPrivacy",
    component: () => import("@/views/share/ztbFactoryUserPrivacy"),
    meta: { title: "纸通宝工厂版隐私政策" }
  },
  {
    path: "/share/supplyChainInformationDerived",
    name: "SupplyChainInformationDerived",
    component: () => import("@/views/share/SupplyChainInformationDerived"),
    meta: { title: "统计数据" }
  },
  {
    path: "/share/business/:id",
    name: "Business",
    component: () => import("@/views/share/Business"),
    meta: { title: "工商个体户" }
  },
  {
    path: "/share/auction/info",
    name: "AuctionInfo",
    component: () => import("@/views/share/AuctionInfo"),
    meta: { title: "竞拍详情" }
  },
  {
    path: "/share/factoryPrint",
    name: "FactoryPrint",
    component: () => import("@/views/share/FactoryPrint"),
    meta: { title: "工厂直印" }
  },
  {
    path: "/share/threeDBoxPreview",
    name: "ThreeDBoxPreview",
    component: () => import("@/views/share/ThreeDBoxPreview"),
    meta: { title: "3D盒型预览" }
  },
  {
    path: "/share/upload",
    name: "Upload",
    component: () => import("@/views/share/Upload"),
    meta: { title: "上传文件" }
  },
  { path: "/404", component: () => import("@/views/error/404") }
];

export const asyncRouterMap = [{ path: "*", redirect: "/404" }];

export default new Router({
  mode: "hash",
  /* scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }, */
  routes: constantRouterMap,
  linkActiveClass: "is-active"
});



// WEBPACK FOOTER //
// ./src/router/index.js